
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/busca",
      function () {
        return require("private-next-pages/busca/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/busca"])
      });
    }
  